import * as React from 'react';

import { Badge } from './badge';
import { libelle, ton } from '../../lib/libelles';
import { cn } from '../../lib/utils';

/**
 * Pastille d'un statut, toujours en français et colorée selon son sens.
 *
 *     <StatutBadge domaine="tripStatus" code={trip.status} />
 *     <StatutBadge domaine="invoiceStatus" code={invoice.status} repli="Brouillon" />
 *
 * Remplace les `<Badge>{x.status}</Badge>` qui affichaient le code brut
 * (CONFIRMED, AT_CUSTOMS_EXIT…) et l'ancien `StatusBadge` qui ne rendait rien
 * pour un code inconnu: un code absent de la table donne un libellé sûr
 * (voir `libelle` dans `lib/libelles.js`), jamais le code ni une pastille vide.
 *
 * `ton` impose une teinte ('success' | 'info' | 'warning' | 'destructive' |
 * 'muted'); sinon elle vient du sens du code.
 */
export function StatutBadge({ domaine, code, repli, ton: tonImpose, className, children, ...props }) {
  const texte = children ?? libelle(domaine, code, repli);
  const variante = tonImpose || ton(domaine, code);
  return (
    <Badge variant={variante} className={cn('whitespace-nowrap', className)} {...props}>
      {texte}
    </Badge>
  );
}

export default StatutBadge;
